<template>
  <div>
    <v-dialog v-if="uploadRegularDialog" v-model="uploadRegularDialog" width="700">
      <v-card>
        <v-card-title>
          Import RegularCode File
        </v-card-title>
        <v-card-text>
          <v-form-file @uploaded="uploadEPL" label="RegularCode File"
                       target="ofd"
                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                       return-url
                       xx-large></v-form-file>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :loading="$store.getters.loading['REGULAR_IMPORT']" @click="importConfirm"
                 color="primary" tile>OK
          </v-btn>
          <v-btn @click="uploadRegularDialog=false" outlined tile>CANCEL
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-page-data-table
        title="Regular Code"
        key-name="id"
        :fields="fields"
        ref="container"
        @create="onDetail"
        @import="importEPL"
        :show-edit="false"
        :show-delete="false"
        :row-actions="rowActions"
        :toolbar-actions="toolActions"
        query-api="REGULAR_QUERY">

      <template v-slot:containerNo="{item}">
        <v-link-text :text="item.containerNo" @click="onDetail(item)"></v-link-text>
      </template>
      <template v-slot:status="{item}">
        <v-btn text tile color="success" small v-if="item.status=='COMPLETED'">
          <v-icon small>mdi-checkbox-marked-circle</v-icon>
          {{ item.status }}
        </v-btn>
        <v-btn text tile color="success" small v-else-if="item.status=='NEW'">
          {{ item.status }}
        </v-btn>
      </template>
    </v-page-data-table>
  </div>
</template>

<script>
import RegularQueryFields from "./fields/RegularQueryFields";

export default {
  name: "ContainerQuery",
  data() {
    return {
      uploadRegularDialog: false,
      fields: RegularQueryFields,
      fileUuid: null,
      blNo:null,
      isAdmin:false,
      items: [
      ],
      rowActions: [],
      toolActions: [
        {
          text: 'upload',
          color: 'primary',
          icon: "mdi-upload",
          accessRole:'SMS_ADMIN',
          action: 'import'
        }
      ]
    }
  },
  created() {
    this.isAdmin=this.$tool.hasRole("SMS_ADMIN");
  },
  methods: {
    onDetail(item) {
      let id = item ? item.id : undefined;
      this.$router.apmRoute("docDetail", {id: id});
    },
    importEPL() {
      this.uploadRegularDialog = true;
    },
    uploadEPL(items) {
      if (items && items.length > 0) {
        this.fileUuid = items[0].uuid;
      }
    },
    importConfirm() {
      this.$request.request("REGULAR_CODE_IMPORT", {fileUuid: this.fileUuid}).then((response) => {
        this.$message.success("Import success");
        this.uploadRegularDialog = false;
        this.$refs.container.query();
      });
    }
  }
}
</script>
